module.exports = __webpack_public_path__ + "static/img/wuxi4.60f24cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/homePortal/wuxi4.jpg
// module id = Wb38
// module chunks = 1